var borders = {
  radius: '4px',
  radiusLg: '8px',
  radiusMax: '100px'
};
export default borders;